export const socialsData = {
    github: 'https://github.com/madanlal1',
    facebook: 'https://www.facebook.com/madanlalls/',
    linkedIn: 'https://www.linkedin.com/in/madanlal1',
    instagram: 'https://www.instagram.com/ls_madan2/',
    twitter: 'https://twitter.com/ls_madan2',
    gitlab: 'https://gitlab.com/madanlal1',
    youtube: 'https://www.youtube.com/channel/UCRcMl3tMMxnNbe8IRt0deJQ'
}